module.exports = __webpack_public_path__ + "static/media/piece5.1cb9da87.png";